import React from "react";

interface SlideContent {
  title?: string;
  subtitle?: string;
  bgColor?: string;
  onEdit?: (content: SlideContent) => void;
  topic?: string;
}

const HeaderTitleSlide = {
  id: "header-title-slide",
  name: "Header Title Slide",
  fields: [
    {
      id: "topic",
      label: "Topic",
      type: "text",
      defaultValue: "Course Topic",
    },
    {
      id: "title",
      label: "Title",
      type: "text",
      defaultValue: "Welcome to the Course",
    },
    {
      id: "subtitle",
      label: "Subtitle",
      type: "text",
      defaultValue: "Let's start our journey",
    },
    {
      id: "bgColor",
      label: "Background Color",
      type: "text",
      defaultValue: "linear-gradient(135deg, #1e3a8a 0%, #1e40af 100%)",
    },
  ],
  render: ({ title, subtitle, bgColor, topic }: SlideContent) => {
    return (
      <div
        className="w-full h-full relative overflow-hidden text-white"
        style={{ background: bgColor }}
      >
        {/* Decorative Shapes */}
        <div className="absolute inset-0 overflow-hidden">
          <div className="absolute -top-20 -right-20 w-96 h-96 bg-white/5 rounded-full blur-2xl" />
          <div className="absolute -bottom-32 -left-20 w-96 h-96 bg-white/5 rounded-full blur-2xl" />
          <div className="absolute top-1/3 right-1/3 w-32 h-32 bg-white/5 rounded-full blur-lg" />
        </div>

        {/* Main Content */}
        <div className="relative z-10 flex flex-col justify-center items-center h-full px-16">
          <div className="max-w-5xl w-full text-center space-y-8">
            {/* Title */}
            <h1 className="text-7xl font-black tracking-tight leading-tight">
              {title}
            </h1>

            {/* Subtitle */}
            <div className="text-3xl font-light text-white/90 max-w-3xl mx-auto">
              {subtitle}
            </div>

            {/* Decorative Line */}
            <div className="w-32 h-1 mx-auto bg-gradient-to-r from-transparent via-white/50 to-transparent" />
          </div>
        </div>

        {/* Bottom Decorative Elements */}
        <div className="absolute bottom-0 left-0 right-0">
          <div className="absolute bottom-0 left-0 right-0 h-1 bg-gradient-to-r from-transparent via-white/30 to-transparent" />
          <div className="absolute -bottom-6 left-1/2 transform -translate-x-1/2 w-24 h-24 bg-white/10 rounded-full blur-xl" />
        </div>

        {/* Topic Badge */}
        <div className="absolute top-8 left-8">
          <div className="inline-flex items-center px-4 py-2 rounded-full bg-white/10">
            <div className="w-2 h-2 rounded-full bg-white mr-3"></div>
            <div className="text-sm font-medium text-white">{topic}</div>
          </div>
        </div>
      </div>
    );
  },
};

export default HeaderTitleSlide;
